import { Form, Input, Modal, ModalProps, notification, Select } from 'antd'
import { useEffect } from 'react'
import {
  Action,
  useAllServicesQuery,
  useCreateActionMutation,
} from 'services/authz'

interface Props extends ModalProps {
  onClose: (withRefresh: boolean) => void
}
export default function CreateAction({ onClose, ...props }: Props) {
  const [form] = Form.useForm<Omit<Action, 'id'>>()

  const { data: services } = useAllServicesQuery({ page: 1, size: 1000 })
  const [createAction, { isLoading, data, error }] = useCreateActionMutation()

  useEffect(() => {
    if (!data?.errors && data?.data.name) {
      notification.success({
        message: 'Success',
        description: `Successfully created action ${data?.data.name}`,
      })
      onClose(true)
    }
  }, [data, onClose])

  useEffect(() => {
    if (error) {
      notification.error({
        message: 'Error',
        description: (error as any)?.data?.errors?.detail,
      })
    }
  }, [error])

  const onFinish = ({
    name,
    description,
    path,
    service_id,
    method,
  }: Omit<Action, 'id'>) => {
    createAction({ name, description, path, service_id, method })
  }
  return (
    <Modal
      title="Create new action"
      centered
      okText="Create"
      onCancel={() => onClose(false)}
      okButtonProps={{ htmlType: 'submit', loading: isLoading }}
      onOk={form.submit}
      {...props}
    >
      <Form layout="vertical" onFinish={onFinish} form={form}>
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Please input action name' }]}
        >
          <Input placeholder="Action name..." />
        </Form.Item>
        <Form.Item
          name="description"
          label="Description"
          rules={[
            { required: true, message: 'Please input action description' },
          ]}
        >
          <Input placeholder="Action description..." />
        </Form.Item>

        <Form.Item
          name="path"
          label="Path"
          rules={[{ required: true, message: 'Please input action path' }]}
        >
          <Input placeholder="Action path..." />
        </Form.Item>

        <Form.Item
          name="method"
          label="Method"
          rules={[{ required: true, message: 'Please select method' }]}
        >
          <Select
            placeholder="Select method..."
            options={[
              { name: 'GET', value: 'GET' },
              { name: 'PUT', value: 'PUT' },
              { name: 'POST', value: 'POST' },
              { name: 'DELETE', value: 'DELETE' },
            ]}
          />
        </Form.Item>

        <Form.Item
          name="service_id"
          label="Service"
          rules={[{ required: true, message: 'Please select service' }]}
        >
          <Select
            placeholder="Select service"
            options={services?.data?.map((item) => ({
              name: item.name,
              value: item.id,
            }))}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}
